/* Produktseite Desktop (19.10.2026, toom-Vorbild): Pfeile auf dem Hauptbild + aktives Vorschaubild sichtbar halten.
   Die Pfeile schalten nicht selbst um, sie klicken das nächste/vorige Vorschaubild — das wiederum löst
   Dawns Original-Knopf aus (schaefer-gallery.js). So bleibt Dawns Logik (aktives Medium, Video, Varianten)
   unverändert. Nur ab 990 px; darunter bleibt die Wischgalerie. */
(function () {
  if (!window.matchMedia || !matchMedia('(min-width: 990px)').matches) return;
  var leiste = document.querySelector('.sh-gal__thumbs');
  var buehne = document.querySelector('.sh-gal > slider-component');
  if (!leiste || !buehne) return;
  var knoepfe = function () { return Array.prototype.slice.call(leiste.querySelectorAll('.sh-gal__thumb')); };
  if (knoepfe().length < 2) return;

  var PFEIL = {
    zurueck: '<path d="M15 6l-6 6 6 6"/>',
    weiter: '<path d="M9 6l6 6-6 6"/>'
  };
  function pfeil(richtung, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rb-pdp-pfeil rb-pdp-pfeil--' + richtung;
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + PFEIL[richtung] + '</svg>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();          // nicht die Lightbox des Bildes öffnen
      var liste = knoepfe();
      var i = liste.findIndex(function (k) { return k.classList.contains('is-active'); });
      if (i < 0) i = 0;
      var ziel = richtung === 'weiter' ? (i + 1) % liste.length : (i - 1 + liste.length) % liste.length;
      liste[ziel].click();
    });
    return b;
  }
  var sprache = (document.documentElement.lang || 'de').slice(0, 2);
  var T = { de: ['Vorheriges Bild', 'Nächstes Bild'], fr: ['Image précédente', 'Image suivante'],
            it: ['Immagine precedente', 'Immagine successiva'], en: ['Previous image', 'Next image'] }[sprache] ||
          ['Vorheriges Bild', 'Nächstes Bild'];
  buehne.appendChild(pfeil('zurueck', T[0]));
  buehne.appendChild(pfeil('weiter', T[1]));

  // Bilder vorladen, damit der Wechsel sofort scharf ist: beim Überfahren eines Vorschaubilds dessen Bild,
  // nach dem Laden der Seite die nächsten drei. (Dawn lädt ausgeblendete Bilder sonst erst beim Anzeigen.)
  function bildZu(knopf) {
    var id = knopf && knopf.getAttribute('data-sh-thumb');
    var item = id && document.querySelector('.product__media-item[data-media-id="' + id + '"]');
    return item && item.querySelector('img');
  }
  function vorladen(knopf) {
    var img = bildZu(knopf);
    if (img && img.loading === 'lazy') img.loading = 'eager';
  }
  leiste.addEventListener('pointerenter', function (e) {
    var k = e.target.closest && e.target.closest('.sh-gal__thumb');
    if (k) vorladen(k);
  }, true);
  window.addEventListener('load', function () {
    setTimeout(function () { knoepfe().slice(1, 4).forEach(vorladen); }, 1500);
  });

  // Lupe beim Überfahren (kein Popup): Dawns bildfüllender Lightbox-Knopf liegt ÜBER .product__media, deshalb
  // erreichten die Mausereignisse schaefer-zoom.js nie. Hier hört die ganze Bildkachel (li) mit, der Klick
  // bleibt beim Knopf und öffnet weiterhin die große Ansicht.
  if (matchMedia('(hover: hover) and (pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var FAKTOR = 2.2;
    var liste = buehne.querySelector('.product__media-list');
    var bildVon = function (item) { return item && item.querySelector('.product__media img'); };
    if (liste) {
      liste.addEventListener('mousemove', function (e) {
        var item = e.target.closest('.product__media-item');
        var img = bildVon(item);
        if (!img || item.querySelector('video, model-viewer, iframe')) return;
        var r = item.getBoundingClientRect();
        if (img.dataset.rbZoom !== '1') {
          img.dataset.rbZoom = '1';
          img.style.transition = 'transform .18s ease-out';
          img.style.transform = 'scale(' + FAKTOR + ')';
        } else {
          img.style.transition = 'none';
        }
        img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      });
      liste.addEventListener('mouseleave', function () {
        liste.querySelectorAll('img[data-rb-zoom="1"]').forEach(function (img) {
          img.dataset.rbZoom = '';
          img.style.transition = 'transform .18s ease-out';
          img.style.transform = '';
        });
      });
      // Beim Bildwechsel die Lupe des alten Bildes zurücksetzen
      new MutationObserver(function () {
        liste.querySelectorAll('.product__media-item:not(.is-active) img[data-rb-zoom="1"]').forEach(function (img) {
          img.dataset.rbZoom = ''; img.style.transform = '';
        });
      }).observe(liste, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  // Aktives Vorschaubild in der Leiste sichtbar halten (bei vielen Bildern scrollt die Leiste waagerecht)
  function sichtbar() {
    var a = leiste.querySelector('.sh-gal__thumb.is-active');
    if (!a) return;
    var l = a.parentElement.offsetLeft, r = l + a.parentElement.offsetWidth;
    var liste = knoepfe(), i = liste.indexOf(a);
    vorladen(liste[i + 1]); vorladen(liste[i - 1]);
    if (l < leiste.scrollLeft) leiste.scrollLeft = l - 8;
    else if (r > leiste.scrollLeft + leiste.clientWidth) leiste.scrollLeft = r - leiste.clientWidth + 8;
  }
  if (window.MutationObserver) {
    new MutationObserver(sichtbar).observe(leiste, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})();
